import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import ROUTES from '@/common/routes';

const useRedirectToHome = (isNeedToRedirect: boolean, shouldReloadPage?: boolean) => {
  const history = useHistory();

  const homeRoute = `${ROUTES.HOME}${history.location.search}`;

  useEffect(() => {
    if (isNeedToRedirect) {
      if (shouldReloadPage) {
        window.location.href = homeRoute;
      } else {
        history.push(homeRoute);
      }
    }
  }, [history, isNeedToRedirect, homeRoute, shouldReloadPage]);
};

export default useRedirectToHome;
